
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import GET_USER_CITIES from "@/apollo/autocomplete-queries/GetUserCities.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootUser_ProfileArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      cities: {
        query: GET_USER_CITIES,
        variables() {
          return this.cityAutocompleteFilter;
        },
        update(data) {
          return data.userCities;
        },
        skip() {
          return !this.citySearchString;
        },
      },
    },
  })

  export default class UserCitiesMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ type: Array, default: () => [] }) country!: string[];
    @Prop({ type: Array, default: () => [] }) state!: string[];
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    cities: DropdownOption[] = [];
    citySearchString = "";

    get mappedCityValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get cityAutocompleteFilter():Query_RootUser_ProfileArgs {
      const conditions: any[] = [];
      if (this.citySearchString.length) {
        conditions.push( {
            city: {
              _ilike: `%${this.citySearchString}%`
            },
          },
        );
      }

      if (this.mappedCityValue.length) {
        conditions.push(
          {
            city: {
              _nin: this.mappedCityValue
            },
          },
        );
      }

      if (this.country.length) {
        conditions.push({
          country: {
            _in: this.country,
          }
        })
      }

      if (this.state.length) {
        conditions.push({
          state: {
            _in: this.state,
          }
        })
      }

      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
      this.cities = [];
    }
  }
